webpackJsonp([70144966829960],{

/***/ 622:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _axios = __webpack_require__(133);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _fragments = __webpack_require__(46);
	
	var _mapper = __webpack_require__(38);
	
	var _Typography = __webpack_require__(20);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	var _Button = __webpack_require__(45);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _TextField = __webpack_require__(127);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	var _Paper = __webpack_require__(92);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _Grid = __webpack_require__(25);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _styles = __webpack_require__(11);
	
	var _reactToastify = __webpack_require__(158);
	
	__webpack_require__(147);
	
	var _site = __webpack_require__(43);
	
	var _site2 = _interopRequireDefault(_site);
	
	__webpack_require__(294);
	
	var _gradient = __webpack_require__(83);
	
	var _gradient2 = _interopRequireDefault(_gradient);
	
	var _metadata = __webpack_require__(42);
	
	var _metadata2 = _interopRequireDefault(_metadata);
	
	var _banner = __webpack_require__(67);
	
	var _banner2 = _interopRequireDefault(_banner);
	
	var _quote = __webpack_require__(68);
	
	var _quote2 = _interopRequireDefault(_quote);
	
	var _footer = __webpack_require__(41);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _constants = __webpack_require__(51);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ContactPage = function (_React$Component) {
	  _inherits(ContactPage, _React$Component);
	
	  function ContactPage() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ContactPage);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      formdata: {
	        name: null,
	        email: null,
	        mobile: null,
	        msg: null
	      }
	    }, _this.onChange = function (e) {
	      var formdata = _this.state.formdata;
	      formdata[e.target.id] = e.target.value;
	      _this.setState({ formdata: formdata });
	    }, _this.submitForm = function () {
	      var formdata = _this.state.formdata;
	
	      _axios2.default.post(_constants.API.enquiry, {
	        mtype: 'Enquiry',
	        template: 'enquiry',
	        name: formdata.name,
	        email: formdata.email,
	        mobile: formdata.mobile,
	        msg: formdata.msg
	      }).then(function (response) {
	        _reactToastify.toast.success('Your enquiry has been sent, thanks.');
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ContactPage.prototype.render = function render() {
	    var _this2 = this;
	
	    var classes = this.props.classes;
	
	    var metadata = (0, _mapper.mapMetaData)(this.props.data.contact);
	    var contact = (0, _mapper.mapContact)(this.props.data.contact);
	    var formdata = this.state.formdata;
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_reactToastify.ToastContainer, null),
	      _react2.default.createElement(_metadata2.default, { data: metadata }),
	      _react2.default.createElement(_banner2.default, {
	        uid: 'contact',
	        title: contact.title,
	        subtitle: contact.subtitle,
	        background: contact.image
	      }),
	      contact.contents.map(function (item, index) {
	        switch (item.type) {
	          case 'channels':
	            {
	              return _react2.default.createElement(Channels, { key: index, item: item });
	            }
	          case 'office':
	            {
	              return _react2.default.createElement(Offices, { key: index, item: item });
	            }
	          case 'text_block':
	            {
	              return _react2.default.createElement(Form, {
	                key: index,
	                item: item,
	                onChange: _this2.onChange,
	                formdata: formdata,
	                submitForm: _this2.submitForm
	              });
	            }
	          // case 'promotion': {
	          //   return <Clients key={index} item={item} />
	          // }
	        }
	      }),
	      _react2.default.createElement(_footer2.default, { policies: this.props.data.policies.edges })
	    );
	  };
	
	  return ContactPage;
	}(_react2.default.Component);
	
	var Channels = (0, _styles.withStyles)(_site2.default)(function (props) {
	  var classes = props.classes,
	      item = props.item;
	
	  return _react2.default.createElement(
	    'div',
	    { className: classes.channels },
	    _react2.default.createElement(
	      'div',
	      { className: classes.contents },
	      _react2.default.createElement(
	        'div',
	        { className: classes.centred },
	        _react2.default.createElement(
	          _Grid2.default,
	          { container: true },
	          _react2.default.createElement(
	            _Grid2.default,
	            { item: true, xs: 12 },
	            _react2.default.createElement(
	              _Typography2.default,
	              { variant: 'display1', className: classes.channelTitle },
	              _react2.default.createElement(_gradient2.default, {
	                text: item.heading.text,
	                fromColor: '#8645B3',
	                toColor: '#89DEF4',
	                direction: 'left'
	              })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: classes.channelList },
	              item.channels.map(function (data) {
	                return _react2.default.createElement(Channel, { channel: data });
	              })
	            )
	          )
	        )
	      )
	    )
	  );
	});
	
	var Channel = (0, _styles.withStyles)(_site2.default)(function (data) {
	  var classes = data.classes,
	      channel = data.channel;
	
	  return _react2.default.createElement(
	    'div',
	    { className: classes.channelListItem },
	    _react2.default.createElement(
	      _Typography2.default,
	      { variant: 'title' },
	      channel.channel.text
	    ),
	    _react2.default.createElement(
	      _Typography2.default,
	      null,
	      _react2.default.createElement(
	        'a',
	        { href: channel.type + ':' + channel.contact.text, className: classes.contactLink },
	        channel.contact.text
	      )
	    )
	  );
	});
	
	var Form = (0, _styles.withStyles)(_site2.default)(function (props) {
	  var classes = props.classes,
	      item = props.item,
	      _onChange = props.onChange,
	      formdata = props.formdata,
	      submitForm = props.submitForm;
	
	  return _react2.default.createElement(
	    'div',
	    { className: classes.contactForm },
	    _react2.default.createElement(
	      'div',
	      { className: classes.contents },
	      _react2.default.createElement(
	        'div',
	        { className: classes.centred },
	        _react2.default.createElement(
	          _Grid2.default,
	          { container: true },
	          _react2.default.createElement(
	            _Grid2.default,
	            { item: true, xs: 12 },
	            _react2.default.createElement(
	              _Typography2.default,
	              { variant: 'display1', className: classes.channelTitle },
	              _react2.default.createElement(_gradient2.default, {
	                text: item.heading.text,
	                fromColor: '#8645B3',
	                toColor: '#89DEF4',
	                direction: 'left'
	              })
	            ),
	            _react2.default.createElement(
	              _Typography2.default,
	              null,
	              item.content.text
	            ),
	            _react2.default.createElement(
	              'form',
	              { noValidate: true, autoComplete: 'off' },
	              _react2.default.createElement(_TextField2.default, {
	                id: 'name',
	                label: 'Name',
	                className: classes.contactFormField,
	                fullWidth: true,
	                margin: 'normal',
	                value: formdata.name,
	                onChange: function onChange(e) {
	                  return _onChange(e);
	                }
	              }),
	              _react2.default.createElement(_TextField2.default, {
	                id: 'email',
	                label: 'Email',
	                className: classes.contactFormField,
	                fullWidth: true,
	                margin: 'normal',
	                value: formdata.email,
	                onChange: function onChange(e) {
	                  return _onChange(e);
	                }
	              }),
	              _react2.default.createElement(_TextField2.default, {
	                id: 'mobile',
	                label: 'Mobile',
	                className: classes.contactFormField,
	                fullWidth: true,
	                margin: 'normal',
	                value: formdata.mobile,
	                onChange: function onChange(e) {
	                  return _onChange(e);
	                }
	              }),
	              _react2.default.createElement(_TextField2.default, {
	                id: 'msg',
	                label: 'Message',
	                multiline: true,
	                rows: 3,
	                fullWidth: true,
	                className: classes.contactFormField,
	                margin: 'normal',
	                value: formdata.msg,
	                onChange: function onChange(e) {
	                  return _onChange(e);
	                }
	              }),
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  _Button2.default,
	                  {
	                    size: 'small',
	                    variant: 'raised',
	                    className: classes.contactFormSubmit,
	                    onClick: function onClick() {
	                      return submitForm();
	                    }
	                  },
	                  'Post form'
	                )
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	});
	
	var Offices = (0, _styles.withStyles)(_site2.default)(function (props) {
	  var classes = props.classes,
	      item = props.item;
	
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)(classes.offices, 'contactForm') },
	    _react2.default.createElement(
	      'div',
	      { className: classes.contents },
	      _react2.default.createElement(
	        'div',
	        { className: classes.centred },
	        _react2.default.createElement(
	          _Grid2.default,
	          { container: true },
	          _react2.default.createElement(
	            _Grid2.default,
	            { item: true, xs: 12 },
	            _react2.default.createElement(
	              _Typography2.default,
	              { variant: 'display1', className: classes.officeTitle },
	              _react2.default.createElement(_gradient2.default, {
	                text: item.heading.text,
	                fromColor: '#efefef',
	                toColor: '#fff',
	                direction: 'left'
	              })
	            ),
	            _react2.default.createElement(
	              _Grid2.default,
	              {
	                container: true,
	                spacing: 40,
	                alignItems: 'flex-start',
	                direction: 'row',
	                justify: 'flex-start'
	              },
	              item.contents.map(function (data) {
	                return _react2.default.createElement(
	                  _Grid2.default,
	                  { item: true, xs: 12, md: 6 },
	                  _react2.default.createElement(
	                    'div',
	                    {
	                      className: (0, _classnames2.default)(classes['officeAddressTheme_' + data.theme])
	                    },
	                    _react2.default.createElement(
	                      _Typography2.default,
	                      { variant: 'title', gutterBottom: true },
	                      data.location.text
	                    ),
	                    _react2.default.createElement(
	                      _Typography2.default,
	                      null,
	                      _react2.default.createElement(
	                        'div',
	                        { className: classes.officeAddress },
	                        data.address.text.split(',').map(function (line) {
	                          return _react2.default.createElement(
	                            'div',
	                            null,
	                            line
	                          );
	                        })
	                      )
	                    )
	                  )
	                );
	              })
	            )
	          )
	        )
	      )
	    )
	  );
	});
	
	exports.default = (0, _styles.withStyles)(_site2.default)(ContactPage);
	var query = exports.query = '** extracted graphql fragment **';

/***/ }),

/***/ 294:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contact-js-062e038c3f09a5771d49.js